exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scroll-dialog>.el-dialog__body{max-height:60vh;overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3fb42540!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/views/OperationManage/SystemConfig/SystemConfig/Components/JuTuiAdShield.vue
// module id = 502
// module chunks = 0